module.exports = __webpack_public_path__ + "img/offline_marker.371f77f0.svg";